import React from 'react';
import { Breadcrumb, Layout } from 'antd';

import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

const { Content: AntdContent } = Layout;


export default function ({ children }: any) {

    const location = useLocation();
    const { pathname } = location;
    const segments = pathname.split('/')

    return (
        <AntdContent style={{ padding: '0 25px', marginTop: 20 }}>
            <Breadcrumb
                items={segments.map((segment, index) => {

                    if (segment == '') {
                        return {
                            href: segment,
                            title: <HomeOutlined />,
                        }
                    }

                    return {
                        href: segments.length == (index + 1) ? '' : `/${segment}`,
                        title: _.upperFirst(segment),
                    }
                })
                    // [
                    //     {
                    //         href: '',
                    //         title: <HomeOutlined />,
                    //     },
                    //     {
                    //         href: '',
                    //         title: (
                    //             <>
                    //                 <UserOutlined />
                    //                 <span>Application List</span>
                    //             </>
                    //         ),
                    //     },
                    //     {
                    //         title: 'Application',
                    //     },
                    // ]
                }
            />
            <br></br>
            <div style={{}}>

                {children}
            </div>
        </AntdContent>
    );
};
